import * as React from "react";
import { WizardHotelPWAFlexComponent } from "../typings";
import { UitkCheckbox } from "uitk-react-switch";
import { locKeys } from "./l10n";
import { ILocalization } from "bernie-l10n";

export const AddCar = ({
  flexComponent,
  changeFormProperties,
  isCarAdded,
  l10n,
  disablePackageOptions
}: {
  flexComponent: WizardHotelPWAFlexComponent;
  isCarAdded: boolean;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  l10n: ILocalization;
  disablePackageOptions?: boolean;
}) => {
  if (!flexComponent.model.enableAddCar) {
    return null;
  }

  return (
    <div className="packageCheckbox">
      <UitkCheckbox
        id="addCar"
        label={l10n.formatText(locKeys.addCarLabel)}
        checked={isCarAdded}
        onChange={changeFormProperties}
        disabled={disablePackageOptions}
      />
    </div>
  );
};
